import { UserAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";

const Navbar = () => {
  const { user, logOut } = UserAuth();

  const handleSignOut = async () => {
    try {
      await logOut();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container mx-auto text-center p-5">
      <div className="flex justify-between w-full">
        <Link to={`/`}>
          <h1 className="text-center text-2xl font-bold">Why-Q Caster</h1>
        </Link>

        {user?.displayName ? (
          <div className="flex items-center">
            {user.photoURL && <img src={user.photoURL} alt="Profile" className="w-10 h-10 rounded-full mr-2" referrerPolicy="no-referrer" onClick={handleSignOut} />}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Navbar;
